<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-07-13 12:50:25
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-07-16 14:45:36
 * @FilePath: \大屏项目\src\components\element\options\cpt-calendar-option.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <t-form labelWidth="80px">
     <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
   <CptDefault :attribute="attribute" :currentCpt="currentCpt" />
   
    <e-collapse title="基础设置" :expand="true">
      <t-form-item label="日期多选">
        <t-switch v-model="attribute.multiple" />
      </t-form-item>
      <t-form-item label="日期格式">
        <t-select v-model="attribute.dateFormat" size="small" @change="handleChange">
          <t-option v-for="(item, index) in defaultTypeArray" :key="index" :label="item.label" :value="item.type" />
        </t-select>
      </t-form-item>
      <t-form-item label="背景颜色">
        <t-color-picker
          size="small"
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.bgColor"
        />
      </t-form-item>
    </e-collapse>
    <e-collapse title="字体设置" :expand="true">
      <t-form-item label="字体颜色">
        <t-color-picker
          size="small"
          :colorModes="['monochrome']"
          format="HEX"
          v-model="attribute.textColor"
        />
      </t-form-item>
      <t-form-item label="字体样式">
        <t-radio-group size="small" v-model="attribute.fontStyle">
          <t-radio-button value="normal">正常</t-radio-button>
          <t-radio-button value="italic">斜体</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="加粗">
        <t-radio-group size="small" v-model="attribute.fontWeight">
          <t-radio-button value="normal">正常</t-radio-button>
          <t-radio-button value="bold">加粗</t-radio-button>
          <t-radio-button value="lighter">更细</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="字体">
        <t-select size="small" v-model="attribute.fontFamily">
          <t-option
            v-for="item in textFamilyList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </t-select>
      </t-form-item>
      <t-form-item label="字体大小">
        <t-input-number
          size="small"
          :min="0"
          :max="9999"
          v-model="attribute.fontSize"
          :decimal-places="0"
        />
      </t-form-item>
    </e-collapse>
    <e-collapse title="边框设置" :expand="true">
      <t-form-item label="边框宽度">
        <t-input-number
          size="small"
          v-model="attribute.borderSize"
          :min="0"
          :max="9999"
          :decimal-places="0"
        />
      </t-form-item>
      <t-form-item label="边框颜色">
        <t-color-picker
          size="small"
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.borderColor"
        />
      </t-form-item>
      <t-form-item label="边框圆角">
        <t-input-number
          size="small"
          v-model="attribute.borderRadius"
          :min="0"
          :max="9999"
          :decimal-places="0"
          
        />
      </t-form-item>
      <t-form-item label="线条类型">
        <t-select size="small" v-model="attribute.lineType">
          <t-option
            v-for="item in lineTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </t-select>
      </t-form-item>
    </e-collapse>
    <e-collapse title="选中设置" :expand="true">
      <t-form-item label="选中背景颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.activeBgColor"
          size="small"
        />
      </t-form-item>
      <t-form-item label="选中边框颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.activeBrColor"
          size="small"
        />
      </t-form-item>
      <t-form-item label="选中字体颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.activeColor"
          size="small"
        />
      </t-form-item>
      <!-- <t-form-item label="当日背景颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.nowBgColor"
          size="small"
        />
      </t-form-item>
      <t-form-item label="当日边框颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.nowBrColor"
          size="small"
        />
      </t-form-item>
      <t-form-item label="当日字体颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.nowColor"
          size="small"
        />
      </t-form-item> -->

    </e-collapse>
    <e-collapse title="下拉框设置" :expand="true">
      <t-form-item label="背景颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.selectBgColor"
          size="small"
        />
      </t-form-item>
      <t-form-item label="边框颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.selectBrColor"
          size="small"
        />
      </t-form-item>
      <t-form-item label="字体颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.selectColor"
          size="small"
        />
      </t-form-item>
      <t-form-item label="选中背景颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.selectActiveBgColor"
          size="small"
        />
      </t-form-item>
      <t-form-item label="选中边框颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.selectActiveBrColor"
          size="small"
        />
      </t-form-item>
      <t-form-item label="选中字体颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.selectActiveColor"
          size="small"
        />
      </t-form-item>
    </e-collapse>
  </t-form>
</template>

<script>
import CptData from "@/components/element/options/comp/cpt-data";
import CptDefault from "@/components/element/options/comp/cpt-default";
import CptInputOptionBase from "@/components/element/options/comp/cpt-input-option-base";
export default {
  name: "cpt-calendar-option",
  props: {
    attribute: Object,
    cptDataForm: Object,
    currentCpt: Object,
  },
  components: { CptDefault,CptInputOptionBase,CptData },
  data() {
    return {
      defaultTypeArray: [
        {
          type: "YYYY",
          label: "年(YYYY)",
        },
        {
          type: "YYYY-MM",
          label: "年月(YYYY-MM)",
        },
        {
          type: "YYYY-MM-DD",
          label: "年月日(YYYY-MM-DD)",
        },
        {
          type: "YYYY-MM-DD hh:mm:ss",
          label: "年月日(YYYY-MM-DD hh:mm:ss)",
        },
      ],
      sizeOptions: {
        small: { width: this.currentCpt.cptWidth, height: 24 },
        medium: { width: this.currentCpt.cptWidth, height: 32 },
        large: { width: this.currentCpt.cptWidth, height: 40 },
      },
      textFamilyList: [],
      lineTypeList: [],
    };
  },
  mounted() {
    //  console.log(this.currentCpt,'attribute')
    this.textFamilyList = require("@/assets/font/font-list");
    this.lineTypeList = require("@/assets/data/line-type");
  },
  methods: {
    handleChange(event) {
      // this.attribute.dateFormat = event;
      console.log("选中的值为：", event);
    },
     changeSize(val) {
      const sizeAttributes = this.sizeOptions[val];
      if (sizeAttributes) {
        this.attribute.width = sizeAttributes.width;
        this.attribute.height = sizeAttributes.height;
      } else {
        console.warn(`Invalid size option: ${val}`);
      }
    },
  },
};
</script>

<style scoped>
</style>